module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@3x-fbb3b2acbd12b3aa6da7a59530530f71.png";